import { action } from 'typesafe-actions'
import { DeliveryTrackingActionTypes } from './types'

export const rescheduleOpen = () => action(DeliveryTrackingActionTypes.RESCHEDULE_OPEN)
export const rescheduleClose = () => action(DeliveryTrackingActionTypes.RESCHEDULE_CLOSE)
export const rescheduleRequest = (deliveryUuid: string) => (
  action(DeliveryTrackingActionTypes.RESCHEDULE_REQUEST, deliveryUuid)
)
export const rescheduleRequestSuccess = () => action(DeliveryTrackingActionTypes.RESCHEDULE_REQUEST_SUCCESS)
export const rescheduleRequestFail = () => action(DeliveryTrackingActionTypes.RESCHEDULE_REQUEST_FAIL)
